import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Input, Select, DatePicker } from 'components';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import { PlanService, ProfileService, UserService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Renew extends React.Component<Props> {

	state = {
		plans: [],
		payment_methods: [],
		bank_accounts: [],
		banks: [],
		form: {
			plan_id: '',
			user_id: '',
			frequency: '',
			payment_method_id: '',
			currency: '',
			bank_id: '',
			payment_phonecode_id: '',
			payment_phone: '',
			payment_name: '',
			payment_email: '',
			payment_document: '',
			payment_date: '',
			reference: '',
			seller_code: '',
			subtotal: 0,
			iva: 0,
			iva_percentage: 0,
			amount: 0,
			amount_bs: 0,
			conversion: 0,
		},
		pending_payment: null
	}

	async componentDidMount() {
		this.props.dispatch({ type: 'SET_HEADER', payload: { title: 'Pagar', onBack: () => this.props.history.push('/affiliate/plan') } });
		this.props.dispatch({ type: 'SET_SUBHEADER', payload: { title: '' } });
		this.load();
	}

	load = async () => {
		const selects: any = await UserService.admin.getSelects();
		const res: any = await ProfileService.getDocumentTypes({ user_id: this.props.user?.id });

		const availablePlan = selects.plans.find((i: any) => i.affiliate_type === this.props.user?.affiliate_type && i.id === this.props.request_plan?.plan_id);

		// Calcula el precio base en base a la frecuencia
		let base_price = 0;
		switch (Number(this.props.request_plan?.frequency)) {
			case 1:
				base_price = Number(availablePlan?.mensual_amount);
				break;
			case 2:
				base_price = Number(availablePlan?.trimestral_amount);
				break;
			case 3:
				base_price = Number(availablePlan?.semestral_amount);
				break;
			case 4:
				base_price = Number(availablePlan?.amount);
				break;
		}

		// Calcula el precio final
		const subtotal = base_price;
		const iva = (base_price * Number(selects?.iva?.percentage || 0)) / 100;
		const amount = base_price + iva;
		const amount_bs = Number(parseFloat(String(amount * selects?.conversion)).toFixed(2));

		const localCurrencies = [Constants.PAYMENT_METHODS.MOVIL];

		this.setState((s: any) => ({
			availablePlan,
			banks: res.banks.map((i: any) => ({ value: i.id, label: i.name })),
			payment_methods: selects.paymentMethods,
			form: {
				...s.form,
				plan_id: Number(availablePlan?.id),
				user_id: this.props.user?.id,
				frequency: Number(this.props.request_plan?.frequency),
				payment_method_id: String(this.props.request_plan?.payment_method_id),
				currency: localCurrencies.includes(this.props.request_plan?.payment_method_id) ? 1 : 2,
				seller_code: this.props.request_plan?.vendorCode || null,
				subtotal,
				iva,
				iva_percentage: selects?.iva?.percentage || 0,
				amount,
				amount_bs,
				conversion: selects.conversion,
			}
		}));
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}

	isValidForm = () => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		const { form, payment_methods } = this.state;

		if (!form.plan_id)
			return onError('Debe seleccionar un plan');

		const selectedMethod: any = payment_methods.find((i: any) => i.id === +form.payment_method_id);
		const isZelle = selectedMethod?.name.toLowerCase().includes('zelle');
		const isExonerado = selectedMethod?.name.toLowerCase().includes('exonerado');
		const isMovil = selectedMethod?.name.toLowerCase().includes('pago');

		if (isZelle) {
			if (!form.payment_email.trim())
				return Globals.showError('Debe ingresar el correo emisor');

			if (!form.payment_name.trim())
				return Globals.showError('Debe ingresar el nombre del emisor');
		}

		if (isMovil) {
			if (!form.payment_date)
				return Globals.showError('Debe ingresar la fecha de pago');

			if (!form.bank_id)
				return Globals.showError('Debe ingresar el banco emisor');

			if (!form.payment_phone.trim())
				return Globals.showError('Debe ingresar el teléfono emisor del pago');
		}
		if (!isExonerado && !form.reference.trim())
			return onError('Debe ingresar la referencia del pago');

		return true;
	}
	submit = async (e: any) => {
		e.preventDefault();
		if (!this.isValidForm()) return;

		const { form, payment_methods } = this.state;
		const selectedMethod: any = payment_methods.find((i: any) => i.id === +form.payment_method_id);
		const isZelle = selectedMethod?.name.toLowerCase().includes('zelle');
		const isExonerado = selectedMethod?.name.toLowerCase().includes('exonerado');

		const todayStr = new Date().toISOString().split('T')[0];

		// Si es exonerado, enviamos datos por defecto para que el backend no rechace la petición
		const payload = {
			...this.state.form,
			payment_document: isExonerado ? String(this.props.user?.document || '0') : form.payment_document.trim(),
			payment_date: todayStr,
			payment_name: isExonerado ? String(this.props.user?.name || 'Exonerado') : form.payment_name.trim(),
			payment_email: isExonerado ? String(this.props.user?.email || 'exonerado@izoo.com') : form.payment_email.trim(),
			reference: isExonerado ? 'EXONERACION' : form.reference.trim(),
		};

		try {
			await PlanService.affiliate.payPlan(payload);

			if (isZelle || isExonerado) {
				Globals.showSuccess('Su solicitud ha sido registrada con éxito. Espere su aprobación');
			} else {
				Globals.showSuccess('Se ha registrado el pago correctamente');
			}

			this.props.history.replace('/affiliate/plan');
			this.props.dispatch({ type: 'SET_REQUEST_PLAN', payload: null });

		} catch (error) {
			console.log(error);
		}
	}
	render() {
		const { form } = this.state;
		const payment_method: any = this.state.payment_methods.find((i: any) => i.id === +form.payment_method_id);

		const isZelle = payment_method?.name.toLowerCase().includes('zelle');
		const isExonerado = payment_method?.name.toLowerCase().includes('exonerado');
		const isMovil = payment_method?.name.toLowerCase().includes('pago');

		return (
			<div id="renew-plan">
				<div className="container">
					{isExonerado && (
						<React.Fragment>
							<p className="title">{payment_method?.name}</p>
							<div style={{ textAlign: 'center', marginTop: 20, marginBottom: 30 }}>
								<p style={{ color: '#FFF', fontFamily: 'Raleway-Medium', fontSize: 16 }}>
									Al continuar, enviará una solicitud de exoneración para su plan.
								</p>
							</div>
						</React.Fragment>
					)}

					{/* VISTA PARA ZELLE */}
					{isZelle && (
						<React.Fragment>
							<p className="title">{payment_method?.name}</p>
							<p className="label-payment">Datos para el pago</p>
							<p className="data-payment"><span>Correo: </span>{payment_method?.email}</p>

							<br />
							<p className="label-verify">Verificación de pago</p>
							<div className="row">
								<div className="col-md-6">
									<Input
										color="white"
										value={form.payment_email}
										name="payment_email"
										placeholder="Correo emisor"
										onChange={this.change} />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={form.payment_name}
										name="payment_name"
										placeholder="Nombre y apellido del titular"
										onChange={this.change} />
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<Input
										color="white"
										value={form.reference}
										name="reference"
										placeholder="Referencia"
										onChange={this.change} />
								</div>
							</div>
						</React.Fragment>
					)}

					{/* VISTA PARA PAGO MÓVIL */}
					{isMovil && (
						<React.Fragment>
							<p className="title">Pago Móvil</p>
							<div className="row px-3">
								<div>
									<p className="label-payment">Datos para el pago</p>
									<p className="data-payment"><span>Banco: </span>{payment_method?.bank?.name}</p>
									<p className="data-payment"><span>Teléfono: </span>{payment_method?.phonecode?.name}-{payment_method?.phone}</p>
									<p className="data-payment"><span>Documento: </span>{payment_method?.document_type?.name}{payment_method?.document}</p>
								</div>

								<div className="right">
									<p className="label-payment">Monto a pagar</p>
									<p className="label-amount">{Globals.formatMiles(form.amount_bs, true, 'Bs.')}</p>
									<p className="data-payment">Subtotal {Globals.formatMiles(form.subtotal * form.conversion, true, 'Bs.')}</p>
									<p className="data-payment">IVA ({form.iva_percentage}%): {Globals.formatMiles(form.iva * form.conversion, true, 'Bs.')}</p>
								</div>
							</div>

							<p className="label-verify">Verificación de pago</p>
							<div className="row">
								<div className="col-md-6">
									<Select
										className="select-bank"
										placeholder="Banco"
										name="bank_id"
										value={form.bank_id}
										onChange={this.change}
										options={this.state.banks} />
								</div>
								<div className="col-md-6">
									<DatePicker
										placeholder="Fecha del Pago"
										maxDate={moment().toDate()}
										onChange={(text: string) => this.change({ target: { value: text, name: 'payment_date' } })}
										value={form.payment_date}
									/>
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={form.payment_phone}
										name="payment_phone"
										placeholder="Teléfono emisor"
										onChange={this.change} />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										placeholder="Referencia"
										name="reference"
										value={form.reference}
										onChange={this.change} />
								</div>
							</div>
						</React.Fragment>
					)}

					<div className="text-center">
						<Button className="btn-next" onClick={this.submit}>
							{isExonerado ? 'REALIZAR SOLICITUD' : 'GUARDAR'}
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user,
		request_plan: state.request_plan,
	}
})(Renew);